var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6988 44.3354C31.7479 44.0091 35.8156 44.0091 39.8646 44.3354C42.0696 44.464 44.2641 44.7398 46.4342 45.1612C51.1302 46.112 54.196 47.6634 55.5099 50.1656C56.4967 52.1185 56.4967 54.4433 55.5099 56.3962C54.196 58.8984 51.2519 60.5499 46.3855 61.4006C44.2171 61.8379 42.0221 62.1221 39.816 62.2514C37.7721 62.4766 35.7283 62.4766 33.6601 62.4766H29.9373C29.1587 62.3765 28.4044 62.3264 27.6745 62.3264C25.4683 62.2129 23.2728 61.937 21.1049 61.5007C16.4089 60.5999 13.3431 58.9985 12.0292 56.4962C11.522 55.527 11.2546 54.4442 11.2503 53.3434C11.24 52.236 11.4993 51.1435 12.0049 50.1656C13.2945 47.6634 16.3603 46.0369 21.1049 45.1612C23.2823 44.7338 25.4853 44.4579 27.6988 44.3354ZM33.7574 6.22656C41.9143 6.22656 48.5267 13.0267 48.5267 21.4151C48.5267 29.8034 41.9143 36.6036 33.7574 36.6036C25.6005 36.6036 18.9881 29.8034 18.9881 21.4151C18.9881 13.0267 25.6005 6.22656 33.7574 6.22656Z",
    fill: "#898989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.36f85da3095c976a7e9cd78b8fa6a330.svg";
export { ForwardRef as ReactComponent };